export default defineNuxtRouteMiddleware((to, from) => {    
    const { setAlert, sportsCombination, setBetSlips} = useStore();
    const { isAuthenticated, principal } = usePrincipal();
    if (isAuthenticated && principal.value) {
      if (principal.value.unreadMessageCount > 0) {
        if (to.path != '/mypage/message') {
            setAlert({
              isShow: true,
              type: 'unread-message',
              data: {
                type: 'warning',
                message: '읽지않은 메세지가 있습니다.'
              }
            })
            return abortNavigation()
        }
      }

      if (principal.value.casino <= 0) {
        if (to.path.includes('casino')) {
          setAlert({
            isShow: true,
            data: {
              type: 'warning',
              message: '카지노 머니가 부족합니다.'
            }
          });
          return abortNavigation();
        }
      }
    }    
    // if (to.path == '/sports/special') {
    //   if (!sportsCombination.value.special.multi) {
    //     setAlert({
    //       isShow: true,
    //       data: {
    //           type: 'warning',
    //           message: '스페셜 베팅이 금지되었습니다.'
    //       }
    //     })
    //     return abortNavigation();
    //   }
    // }
})